// extracted by css-extract-rspack-plugin
export default {"cls1":"MobileChipize-cls1_J0h","cls2":"MobileChipize-cls2_jxk MobileChipize-cls1_J0h"};